import { useCallback, useMemo, useState } from 'react'
import { useTheme } from '@mui/material'
import useRolesViews from 'hooks/useRolesViews'
import type { TaskListElement } from 'shared/graphql/graphql'
import { TASK_STATES, TASK_TYPES } from '../../ContentLists/TaskList/constants'
import { SIDE_MENU_TRANSLATIONS, SIDE_MENU_OPTIONS } from '../../SideMenu/constants'
import type { UseFilterConfigurationProps } from './types'
import useFilterConfiguration from './use-filter-configuration'

export const useShiftUpdates = ({ isOffice }: UseFilterConfigurationProps) => {
  const [favurUuid, setFavurUuid] = useState<string | undefined>()
  const { palette } = useTheme()
  const { setActiveView } = useRolesViews()
  const { configuration, loading: configLoading } = useFilterConfiguration({
    isOffice,
    officeDefaultTaskState: TASK_STATES.pending,
  })
  const initialFilters = useMemo(
    () => ({
      // Camelcase used for the filter query variables
      // eslint-disable-next-line camelcase
      task_types: [TASK_TYPES.shiftUpdate],
    }),
    [],
  )
  const onTaskClick = useCallback(
    ({ task }: { task: TaskListElement }) => {
      if (task?.favurUuid) {
        setFavurUuid(task?.favurUuid)
        setActiveView(isOffice ? 'office' : 'frontliner')
      }
    },
    [isOffice, setActiveView],
  )
  const onGoBack = () => setFavurUuid(undefined)

  return {
    configuration,
    initialFilters,
    configLoading,
    onTaskClick,
    backgroundColor: palette.background.default,
    favurUuid,
    setFavurUuid,
    onGoBack,
    displayNestedContent: Boolean(favurUuid),
    adminTitleKey: SIDE_MENU_TRANSLATIONS[SIDE_MENU_OPTIONS.adminShiftUpdates],
    personalTitleKey: SIDE_MENU_TRANSLATIONS[SIDE_MENU_OPTIONS.personalShiftUpdates],
  }
}
